import qs from 'qs';

type QueryParameter = {
  name: string;
  value: unknown;
}

type QueryParams = Record<string, unknown>;

export const parseSearchParamsRouter = (locationSearch: string) => {
  return qs.parse(locationSearch, {
    ignoreQueryPrefix: true,
    decoder(str, decoder, charset) {
      const strWithoutPlus = str.replace(/\+/g, ' ');
      if (charset === 'iso-8859-1') {
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }

      if (/^(\d+|\d*\.\d+)$/.test(str)) {
        return parseFloat(str);
      }

      const keywords: Record<string, unknown> = {
        true: true,
        false: false,
        null: null,
        undefined,
      };

      if (str in keywords) {
        return keywords[str];
      }

      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    },
  });
};

export const getSearch = (search: string) => {
  const params = parseSearchParamsRouter(search);
  if (params.search) {
    return params.search as string;
  }
  return;
};

export const getPage = (search: string) => {
  const params = parseSearchParamsRouter(search);
  if (params.page) {
    return params.page as number;
  }
  return;
};

export const getSort = (search: string) => {
  const params = parseSearchParamsRouter(search);
  if (params.sort) {
    return params.sort as string;
  }
  return;
};

export const getKeywords = (search: string) => {
  const params = parseSearchParamsRouter(search);
  if (params.keywords) {
    return params.keywords;
  }
  return '';
};

export const getFilters = (search: string, filter: string) => {
  const params = parseSearchParamsRouter(search);
  if (params[filter]) {
    return params[filter];
  }
  return false;
};

const createQueryString = (queryParamsObj: QueryParams) => {
  const queryString = qs.stringify(queryParamsObj, { arrayFormat: 'brackets', skipNulls: true });

  return `?${queryString}`;
}

export const addToQueryStringFrom = (search: string, queryParams: QueryParameter[]) => {
  let currentParams = parseSearchParamsRouter(search);

  queryParams.forEach(queryItem => {
    currentParams = {
      ...currentParams,
      [queryItem.name]: queryItem.value,
    };
  });

  return createQueryString(currentParams);
};

export const addToQueryString = (queryParams: QueryParameter[]) => addToQueryStringFrom(window.location.search, queryParams);

export const getQueryStringFrom = (queryParams: QueryParameter[]) => {
  const filteredQueries = queryParams.filter(q => q.value);
  let paramsObj = {};

  filteredQueries.forEach(query =>{
    paramsObj = {
      ...paramsObj,
      [query.name]: query.value,
    }
  })

  return createQueryString(paramsObj);
}
